 
import { ChargingPoint } from '@/types/ChargingPoint'

import { useToast } from '@/contexts/ToastContext'
import { HttpError } from '@/api/http'
import { useMutationPostChargingStop } from '@/api/charging/mutations'
import { Logger } from '@/lib/logger'

const logger = new Logger('useStopCharging')

export interface UseStopChargingProps {
  chargingPoint: ChargingPoint | undefined
  onSuccess: () => void
}

export const useStopCharging = ({ chargingPoint, onSuccess }: UseStopChargingProps) => {
  const { show } = useToast()

  const startChargingMutation = useMutationPostChargingStop({
    onSuccess,
    onError: (error: HttpError) => {
      show(error.message || 'Ocorreu um erro ao finalizar a sessão!', { severity: 'error' })
    },
  })

  const confirmChargingStop = async (): Promise<void> => {
    try {
      await startChargingMutation.mutateAsync({
        charging_point_id: chargingPoint?.id as number,
      })
    } catch (error) {
      logger.error('Erro ao finalizar o carregamento:', error)
    }
  }

  return { confirmChargingStop, isPending: startChargingMutation.isPending }
}
